
















import { TcPageAlert } from '@telia/shared-ui-components'
import {
  computed,
  defineComponent,
  onMounted,
  watch,
  ref,
  Ref
} from '@vue/composition-api'
import {
  AnslGenericPageAlerts
} from '@/components/common'
import {
  getLoading, getException, fetchContent, getContent
} from '@/store/modules/landing-page.store'
import { ElementRef } from '@/types/common.types'
import { scrollTo } from '@/utils/window.utils'

import AnslProductContainerCf from '@/components/landing-page/ProductContainerCf.vue'
import AnslInfoBannerCf from '@/components/landing-page/InfoBannerCf.vue'
import AnslHero from '@/components/landing-page/Hero.vue'
import FlowEntryPointCf from '@/flows/FlowEntryPointCf.vue'

export default defineComponent({
  props: {
    scrollToAddressSearch: Boolean
  },
  components: {
    AnslHero,
    AnslProductContainerCf,
    AnslInfoBannerCf,
    AnslGenericPageAlerts,
    FlowEntryPointCf,
    TcPageAlert
  },
  setup (props, context) {
    const flowEntryPointRef: Ref<ElementRef> = ref({} as ElementRef)
    const store = context.root.$store

    fetchContent(store)

    const loading = computed(() => getLoading(store))
    const exception = computed(() => getException(store))
    const loaded = computed(() => !loading.value && !exception.value)
    const content = computed(() => getContent(store))
    const scrollToAddressSearch = computed(() => props.scrollToAddressSearch)
    const flowEntryPointOffsetTop = computed(() => flowEntryPointRef.value.$el?.offsetTop)

    onMounted(() => {
      if (scrollToAddressSearch.value) {
        scrollTo(flowEntryPointOffsetTop.value)
      }
    })

    watch(() => scrollToAddressSearch.value, (value) => value && scrollTo(flowEntryPointOffsetTop.value))

    return {
      loading,
      exception,
      loaded,
      content,
      flowEntryPointRef
    }
  }
})
